<div class="trucking-component">
  <div class="heading flex flex-row justify-between">
    <h2>Trailers</h2>
    <div class="self-center">
      <div class="search-bar-container">
        <select [(ngModel)]="selectedCategory" class="category-select">
          <option value="trailerName">Trailer Name</option>
          <option value="trailerTypeName">Trailer Type</option>
          <option value="subcarrierName">Subcarrier Name</option>
        </select>
        <input
          type="text"
          class="search-bar"
          placeholder="Search..."
          [(ngModel)]="searchQuery"
          (input)="filterTrailers()"
        />
        <button *ngIf="searchQuery" class="clear-button self-center" (click)="clearSearch()">Clear</button>
      </div>
    </div>
  </div>

  <div>
    <div class="grid grid-cols-7 gap-1 table-header items-center">
      <div class="clickable-header" (click)="sortTrailers('trailerName')">
        Trailer Number {{ sortIcons.trailerName }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('trailerTypeName')">
        Trailer Type {{ sortIcons.trailerTypeName }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('trailerRegion')">
        Assigned Region {{ sortIcons.trailerRegion }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('trailerStatus')">
        Trailer Status {{ sortIcons.trailerStatus }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('subcarrierName')">
        Assigned Subcarrier {{ sortIcons.subcarrierName }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('createdTimestamp')">
        Created Date {{ sortIcons.createdTimestamp }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('archivedTimestamp')">
        Archived Date {{ sortIcons.archivedTimestamp }}
      </div>
    </div>

    <div class="table-body">
      <div
        *ngFor="let trailer of sortedArchivedTrailers; trackBy: trailers | trackByKey: 'trailerId'"
        class="grid grid-cols-7 gap-1 items-center row cursor-pointer"
      >
        <div class="cell">{{ trailer.trailerName }}</div>
        <div class="cell">{{ trailer.trailerTypeName | dashIfNothing }}</div>
        <div class="cell">{{ trailer.trailerRegion | dashIfNothing }}</div>
        <div class="cell">{{ prettyStatus(trailer.trailerStatus) }}</div>
        <div class="cell">{{ trailer.subcarrierName | dashIfNothing }}</div>
        <div class="cell">{{ trailer.createdTimestamp | date: 'H:mm LLL dd' }}</div>
        <div *ngIf="!canManageTrailerManagement.value" class="cell">
          {{ trailer.archivedTimestamp | date: 'H:mm LLL dd' }}
        </div>
        <div *ngIf="canManageTrailerManagement.value" class="cell flex justify-between">
          <div>
            {{ trailer.archivedTimestamp | date: 'H:mm LLL dd' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="createEdit$$ | async as openCreate">
  <div class="back-layer-component" (click)="closeNewTrailerForm()"></div>
  <sa-trailer-management-create-edit
    [editTrailer]="openCreate"
    [trailerTypes]="trailerTypes"
    [subcarriers]="subcarriers"
    (onCloseClicked)="closeNewTrailerForm()"
  >
  </sa-trailer-management-create-edit>
</ng-container>
